var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{class:_vm.componenteClass(_vm.componente.tipografia)},[_vm._v(_vm._s(_vm.componente.text.label['es_ES']))])])
}
var staticRenderFns = []

export { render, staticRenderFns }